import React from 'react';
import PropTypes from 'prop-types';
import Card from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Badge from '@/components/ui/Badge';
import Typography from '@/components/ui/Typography';

/**
 * PackCard
 * Reusable card to present a pack with actions
 */
export default function PackCard({
  pack,
  isOwned = false,
  inCart = false,
  onToggleCart = () => {},
  className = '',
  children
}) {
  if (!pack) return null;

  const { id, name, description, price } = pack;

  return (
    <Card
      className={`rounded-xl shadow-md border border-neutral-200 transition-all duration-200 hover:shadow-lg hover:bg-neutral-50 ${className}`}
      title={null}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <Typography variant="h3" bold className="truncate">
            {name}
          </Typography>
          <Typography variant="body1" className="text-neutral-600 mt-1">
            {description}
          </Typography>
          {children && <div className="mt-3">{children}</div>}
        </div>

        <div className="flex flex-col items-end gap-3">
          <div className="text-right">
            <Typography variant="h2" bold style={{ color: '#1f2937' }}>
              €{(price ?? 0).toFixed(2)}
            </Typography>
          </div>

          {isOwned ? (
            <Badge variant="success" size="md" pill>
              Possédé
            </Badge>
          ) : (
            <Button
              variant={inCart ? 'outline' : 'primary'}
              size="medium"
              onClick={() => onToggleCart(id)}
              bold
              leftIcon={!inCart ? <span aria-hidden="true">🛒</span> : undefined}
              className="w-full"
            >
              {inCart ? 'Retirer' : 'Ajouter au panier'}
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
}

PackCard.propTypes = {
  pack: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.number
  }).isRequired,
  isOwned: PropTypes.bool,
  inCart: PropTypes.bool,
  onToggleCart: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node
};
